"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const query_string_1 = require("query-string");
const __1 = require("..");
class Orders {
    static async Save(data) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/create-orders`;
            let response = await axios_1.default.post(url, data, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetListing(filters) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            if (!filters.page) {
                filters.page = 1;
            }
            // let url = `${Config.ONLINE_API_URL}/api/admin/v1/get-orders?${stringify(filters)}`;
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/get-orders?${(0, query_string_1.stringify)(filters)}`;
            let response = await axios_1.default.get(url, options);
            let _data = response.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOrdersCSV(filters) {
        try {
            const options = {
                withCredentials: true,
                responseType: 'blob'
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            if (!filters.page) {
                filters.page = 1;
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/get-orders-csv?${(0, query_string_1.stringify)(filters)}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async ExportOrdersSAP(filters) {
        try {
            const options = {
                withCredentials: true,
                responseType: 'blob'
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            if (!filters.page) {
                filters.page = 1;
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/get-orders-sap-xlsx?${(0, query_string_1.stringify)(filters)}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async UpdateSingle(data) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/update-orders`;
            let response = await axios_1.default.post(url, {
                ...data,
                order_id: data.id
            }, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async ApproveMany(order_ids = [], status = false) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/approve-orders?status=${status}`;
            let response = await axios_1.default.post(url, order_ids, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async DeleteMany(order_ids = []) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/delete-orders`;
            let response = await axios_1.default.post(url, order_ids, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = Orders;
